import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SECURE911 } from '@rsos/constants/spatialLayers';
import { callQueueSelector } from '@rsos/reduxDataStore/src/features/selectors/callQueueSelector';
import checkAniAliAccessSelector from '@rsos/utils/checkAniAliAccessSelector';
import useHasAccessToSecure911 from './useHasAccessToSecure911';

const useHasOnsiteNotificationAdr = callerId => {
  const hasAccessToSecure911 = useHasAccessToSecure911();

  const hasAniAliAccess = useSelector(state =>
    checkAniAliAccessSelector({ psaps: state.psaps, sinatra: state.sinatra }),
  );
  const hasOnsiteNotificationAdr = useSelector(state => {
    const filteredCalls = callQueueSelector(
      state.emergencyCalls.callQueue,
      hasAniAliAccess,
    );
    const currentCallAdr = filteredCalls?.[callerId]?.additionalData;

    const orgs = [SECURE911];

    // Checks if there is ADR from specific data sources that are considered as
    // onsite notification ADR
    const hasData = orgs.some(org => {
      const orgData = currentCallAdr?.[org];
      // If org data exists
      if (orgData) {
        if (org === SECURE911) {
          // Simple check on the data structure for the org. Assume only one
          // item in the list. No org currently has multiple sets of data
          if (Array.isArray(orgData) && typeof orgData?.[0] === 'object') {
            return (
              !!orgData?.[0]?.data?.spatial_object_id &&
              !!orgData?.[0]?.data?.caller_id
            );
          }
          return false;
        }
        return false;
      }
      return false;
    });

    return hasData;
  });

  const hasAccess = useMemo(() => {
    return [hasAccessToSecure911].some(access => !!access);
  }, [hasAccessToSecure911]);

  return hasAccess && hasOnsiteNotificationAdr;
};

export default useHasOnsiteNotificationAdr;
